<div class="splash scrollbar">
  <div class="splash_logo">
    <img alt="Papers Logo" src="assets/img/readcube-text-logo.svg" />
  </div>

  <br>
    <span class="text--lg">
      SmartCite comes with your Papers subscription
    </span>
  <br>
  <br>
    We did not find an active subscription for <a [href]="webappUrl" target="_blank">{{ (userService.user$ | async)?.name }}</a>.
  <br>
  <br>
    Try our 30-day free trial or subscribe at <a href="https://www.papersapp.com/" target="_blank">papersapp.com</a>!
  <br>
  <br>

  <a
    target=_blank 
    href="https://www.papersapp.com/pricing/"> 
    <button class="button-primary uppercase">
      Learn more
    </button>
  </a>

  <br>
  <br>
  <br>

  <button 
    class="button-primary button-primary--grey uppercase"
    (click)="onLogoutClick()">
    Log out
  </button>

  <br>
</div>